/* sop-qv-radio-fix.js — force label->radio selection inside Graphene quickview portal */
(function () {
  var ROOT_SEL = ".quickview-portal-container";

  // Optional debug: window.SOP_QV_DEBUG = true
  var DEBUG = !!window.SOP_QV_DEBUG;
  function log() { if (DEBUG) console.log.apply(console, ["[sop-qv]"].concat([].slice.call(arguments))); }

  function cssEscape(id) {
    if (window.CSS && CSS.escape) return CSS.escape(id);
    // basic fallback
    return String(id).replace(/([ #;?%&,.+*~\':"!^$[\]()=>|\/@])/g, "\\$1");
  }

  function getInputForLabel(label) {
    if (!label) return null;
    var id = label.getAttribute("for");
    if (!id) return null;

    // IMPORTANT: scope to the same quickview container first (handles duplicate IDs elsewhere)
    var root = label.closest(ROOT_SEL) || document;
    var scoped = root.querySelector("#" + cssEscape(id));
    return scoped || document.getElementById(id);
  }

  function forceCheck(input) {
    if (!input) return false;
    if (input.disabled) return false;
    if (input.checked) return false;

    input.checked = true;

    // Trigger whatever Dawn/your theme listeners are expecting
    try { input.dispatchEvent(new Event("input", { bubbles: true })); } catch (e) {}
    try { input.dispatchEvent(new Event("change", { bubbles: true })); } catch (e) {}

    log("Forced checked:", input);
    return true;
  }

  function onAnyTap(e) {
    var t = e.target;
    if (!t || !t.closest) return;

    // Only inside Graphene quickview portal
    var root = t.closest(ROOT_SEL);
    if (!root) return;

    // If they clicked on a label (or something inside it), force-check its input
    var label = t.closest("label[for]");
    if (!label) return;

    var input = getInputForLabel(label);
    if (!input) return;

    // Only radios/checkboxes
    var type = (input.type || "").toLowerCase();
    if (type !== "radio" && type !== "checkbox") return;

    forceCheck(input);
  }

  // Capture phase so we run even if other handlers stop propagation / preventDefault
  document.addEventListener("click", onAnyTap, true);
  document.addEventListener("pointerup", onAnyTap, true);
  document.addEventListener("touchend", onAnyTap, true);
})();


/* ===================== SOP QV ATC FIX v4 (use cart-drawer.renderContents, non-destructive) ===================== */
(function () {
  if (window.__SOP_QV_ATC_FIX_V4__) return;
  window.__SOP_QV_ATC_FIX_V4__ = true;

  var DEBUG = !!window.SOP_QV_DEBUG;
  function log() { if (DEBUG) console.log.apply(console, ["[sop-qv-atc-v4]"].concat([].slice.call(arguments))); }
  function warn() { console.warn.apply(console, ["[sop-qv-atc-v4]"].concat([].slice.call(arguments))); }

  var SECTION_KEYS = "cart-drawer,cart-icon-bubble";

  function closest(el, sel) {
    while (el && el.nodeType === 1) {
      if (el.matches(sel)) return el;
      el = el.parentElement;
    }
    return null;
  }

  function inQuickview(el) {
    return !!closest(el, ".quickview-portal-container");
  }

  function findATCForm(root) {
    if (!root) return null;
    return root.querySelector('form[action^="/cart/add"]');
  }

  function setLoading(form, on) {
    var btn = form && form.querySelector('button[type="submit"]');
    if (!btn) return;
    btn.toggleAttribute("aria-busy", !!on);
    btn.toggleAttribute("disabled", !!on);
    var sp = btn.querySelector(".loading-overlay__spinner");
    if (sp) sp.classList.toggle("hidden", !on);
  }

  function showError(root, msg) {
    var wrap = root && root.querySelector(".product-form__error-message-wrapper");
    var text = root && root.querySelector(".product-form__error-message");
    if (text) text.textContent = msg || "Unable to add to cart.";
    if (wrap) wrap.hidden = false;
  }

  function openCartDrawerFallback() {
    var cd = document.querySelector("cart-drawer");
    if (cd && typeof cd.open === "function") { cd.open(); return; }

    var el =
      document.querySelector("#cart-icon-bubble") ||
      document.querySelector('[aria-controls*="CartDrawer"]') ||
      document.querySelector('a[href="/cart"]') ||
      document.querySelector('a[href^="/cart"]');

    if (el) el.click();
  }

  function renderCartWithSections(sectionsObj, idForRender) {
    var drawer = document.querySelector("cart-drawer");
    if (drawer && typeof drawer.renderContents === "function") {
      try {
        drawer.renderContents({ id: idForRender || null, sections: sectionsObj });
        try { drawer.classList.remove("is-empty"); } catch (e) {}
        return true;
      } catch (e) {
        warn("cart-drawer.renderContents failed", e);
      }
    }

    try { document.dispatchEvent(new CustomEvent("cart:refresh")); } catch (e) {}
    try { window.dispatchEvent(new Event("cart:refresh")); } catch (e) {}

    return false;
  }

  function fetchAndRenderSections(idForRender, after) {
    var cartUrl = (window.routes && routes.cart_url) ? routes.cart_url : "/cart";
    var q = cartUrl + (cartUrl.indexOf("?") > -1 ? "&" : "?") + "sections=" + encodeURIComponent(SECTION_KEYS);

    fetch(q, { credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        try {
          if (!sections || typeof sections !== "object") return;
          renderCartWithSections(sections, idForRender || null);
        } catch (e) {}
      })
      .catch(function () {})
      .finally(function () {
        if (typeof after === "function") after();
      });
  }

  function ensureSectionsOnFormData(fd) {
    try {
      fd.append("sections", SECTION_KEYS);
      fd.append("sections_url", window.location.pathname + window.location.search);
    } catch (e) {}
    return fd;
  }

  function doAddToCart(form, root) {
    if (!form || !root) return;

    if (form.dataset.sopSubmitting === "1") return;
    form.dataset.sopSubmitting = "1";

    var idInput = form.querySelector('input[name="id"]');
    var variantId = idInput && idInput.value ? String(idInput.value) : "";
    if (!variantId) {
      showError(root, "Please select an available size.");
      form.dataset.sopSubmitting = "0";
      return;
    }

    var fd = new FormData(form);
    ensureSectionsOnFormData(fd);

    var url = "/cart/add.js";

    setLoading(form, true);
    log("POST", url, { id: variantId });

    fetch(url, {
      method: "POST",
      headers: { "Accept": "application/json", "X-Requested-With": "XMLHttpRequest" },
      body: fd,
      credentials: "same-origin"
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (j) { throw j; }).catch(function () {
            throw new Error("Add to cart failed (" + res.status + ")");
          });
        }
        return res.json();
      })
      .then(function (data) {
        log("Added:", data);

        var rendered = false;
        if (data && data.sections) {
          rendered = renderCartWithSections(data.sections, data.id || variantId);
        }

        var openAfter = function () {
          setTimeout(function () {
            var drawer = document.querySelector("cart-drawer");
            if (drawer && typeof drawer.open === "function") {
              try { drawer.open(); return; } catch (e) {}
            }
            openCartDrawerFallback();
          }, 0);
        };

        if (!rendered) {
          fetchAndRenderSections(data && (data.id || data.key) ? (data.id || data.key) : variantId, openAfter);
        } else {
          openAfter();
        }
      })
      .catch(function (err) {
        warn("Add error:", err);
        var msg =
          (err && err.description) ||
          (err && err.message) ||
          "Unable to add to cart. Please try again.";
        showError(root, msg);
      })
      .finally(function () {
        setLoading(form, false);
        form.dataset.sopSubmitting = "0";
      });
  }

  function onTrigger(ev) {
    var t = ev.target;
    if (!t || !inQuickview(t)) return;

    var btn = t.closest ? t.closest('button[type="submit"]') : closest(t, 'button[type="submit"]');
    if (!btn) return;

    var root = btn.closest ? btn.closest(".quickview-portal-container") : closest(btn, ".quickview-portal-container");
    if (!root) return;

    var form = btn.form || findATCForm(root);
    if (!form) return;

    var action = (form.getAttribute("action") || "");
    if (action.indexOf("/cart/add") === -1) return;

    ev.preventDefault();
    ev.stopPropagation();
    if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();

    doAddToCart(form, root);
  }

  document.addEventListener("pointerup", onTrigger, true);
  document.addEventListener("click", onTrigger, true);

  log("Loaded");
})();
